var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('intervenants',{attrs:{"type":'exposant'}},[_vm._v(" Aucun exposants n'est encore annoncés pour cette édition. ")])}
var staticRenderFns = []

export { render, staticRenderFns }